<template>
  <div class="content-wrapper campaigns-container">
    <campaigns-performance-filter
      :loading="!ready.filter && ready.hasData"
      :disabled="!ready.campaigns"
      :show="ready.filter"
      v-model="filter"
      @input="(model) => { $_changeFilter(model); ready.filter = true}"
      @noData="() => {ready.hasData = false}"
    />

    <!-- Campaigns Stats Cards -->
    <CampaignsStats
      :cost="table.statsTotals.cost"
      :revenue="table.statsTotals.tr_revenue"
      :net="table.statsTotals.tr_net"
      :roi="table.statsTotals.tr_roi"
      :cpc="table.statsTotals.avg_cpc"
      :cpa="table.statsTotals.tr_cpa"
      :epc="table.statsTotals.tr_epc"
      :est_cost="table.statsTotals.estimate_cost"
      :est_net="table.statsTotals.estimate_net"
      :est_roi="table.statsTotals.estimate_roi"
      :loading="!$c_readyAll"
    />

    <!--BANNER-->
    <!-- <banner
          targetUrl="https://blog.theoptimizer.io/1465/meet-us-at-affiliate-world-europe-2019/"
          imageUrl="/sh_static/img/banners/AWE2019_artworks_banner_app.png">
          <template slot="bottom">
            <space></space>
          </template>
        </banner> -->

    <!--BANNER WEBINAR-->
    <!-- <banner-webinar
            target-url="http://trc.theoptimizer.io/3550211d-b770-43e4-84cc-4687e7d7d813?src=1"
          >
            <template slot="bottom">
              <space />
            </template>
          </banner-webinar> -->

    <!--CAMPAIGNS DATATABLE-->
    <loading-skeleton
      v-if="!$c_readyAll"
      class="margin-top"
      type="table"
      :table="{ headItems: 6, bodyItems: 20, filters: true, search: true, filterItems: 2 }"
    />
    <div v-else :class="`campaigns-container__table optimizer-table campaigns-table ${filter.type.uniqueName}`">
      <vue-opti-table-light
        v-if="table.fields.length > 0"
        :name="$c_tableName"
        :server-side-pagination="true"
        :pages="pages"
        :page="page"
        :hover="true"
        @on-pagination="$_setPaginationValues($event)"
        :export-label="$c_exportLabel"
        @on-search="$_setSearchValue($event)"
        :resized-columns="resizedColumns"
        @resize="$_handleColumnsResize($event)"
        :selectable="true"
        @on-row-per-page-change="$_setPaginationValues($event)"
        select-label="Campaigns"
        @on-sort="$_setPaginationValues($event)"
        :header-fields="$c_tableHeaders"
        @on-column-filter="$_setColumnFilterValues($event)"
        :items="table.items"
        v-model="tableModel"
        :sort="{ key: 'cost', order: 'desc' }"
        :default-rows="defaultRows"
        :totals="table.totals"
        :save-settings="$_saveSettings"
        :export-csv-items="$_exportCsvItems"
        :column-filter-enable="true"
        :column-filter.sync="columnFilter"
        :column-filter-reset="false"
        row-key="id"
        sticky
      >
        <template #search>
          <vue-opti-select-light
            :class="[ tableModel.selectedRows.length ? 'active-select' : '', 'optimizer-select icon-select dropdown-auto-width pr-md-2 col-md-auto']"
            :options="bulkActionOptions"
            unique-key="value"
            label-key="content"
            button-type="static"
            single.prevent
            prevent
            single
            @click="(item) => { $_bulkAction(item.value) }"
          >
            <template #BUTTON_PLACEHOLDER>
              <span class="button-placehoder-filter">
                <i class="fa fa-ellipsis-h"></i>
                <span>Actions</span>
              </span>
            </template>
          </vue-opti-select-light>

          <vue-opti-select-light
            class="optimizer-select icon-select col-md-auto pl-md-0 pr-md-2"
            :options="statusOptions"
            unique-key="content"
            label-key="content"
            option-type="checkbox"
            :groups="[{ value: 'status', content: 'Status'}]"
            button-type="static"
            v-model="statusFilter"
          >
            <template #BUTTON_PLACEHOLDER="{ options }">
              <span class="button-placehoder-filter">
                <i class="fa fa-filter"></i>
                <span>Filters</span>
                <b-badge v-show="options.length" pill variant="info">{{ options.length }}</b-badge>
              </span>
            </template>
          </vue-opti-select-light>

          <div v-show="userAction.loading" class="col-md-auto" style="line-height: 2.5em">
            <i class="fa fa-spinner fa-spin" /> Processing...
          </div>
          <div v-show="ready.pagination" class="col-md-auto" style="line-height: 2.5em">
            <i class="fa fa-spinner fa-spin" /> Loading...
          </div>
        </template>
        <template #actions="{ item }">
          <div class="d-flex justify-content-center">
            <switch-button
              :checked="item.enabled"
              :hover-title="{ enabled: 'Disable', disabled: 'Enable' }"
              :update="(value) => $_updateStatus(item, value)"
            />
          </div>
        </template>
        <template #name="{ item }">
          <campaign-name :campaign="item" :traffic-source-type="filter.type" :tracker-accounts-map="trackerAccountsMap" :campaign-rules-map="rules.campaignsMap" :route="$route" :moment="moment" />
        </template>
        <template
          slot="cpc"
          slot-scope="props"
        >
          <span v-if="!isEditableField(props.item.traffic_source_unique_name, 'cpc')">{{ props.item.cpc }}</span>
          <live-edit
            v-else
            :ref="`bidLiveEdit-${props.i}`"
            :key="`bidLiveEdit-${props.item.campaign_id}`"
            v-model="props.item.cpc"
            prefix="$"
            :format="$_cpcSlotNumFormat(props.field.options)"
            field-name="Bid"
            :max-limit-warning="maxCpcLimit"
            :inlineEditable="!supportsBidType(props.item.traffic_source_unique_name)"
            @changeValue="$_showUpdateModal('cpc', props.item)"
            :beforeBlur="value => $_updateBid(props.item, value, props.item.bid_strategy)"
            @up="$_inlineEditArrayPress('bidLiveEdit', props.i, 'up')"
            @down="$_inlineEditArrayPress('bidLiveEdit', props.i, 'down')"
          />
        </template>
        <template
          slot="budget"
          slot-scope="props"
        >
          <span v-if="props.item.budget_type === 'unsupported'">Unsupported</span>
          <span v-else-if="!isEditableField(props.item.traffic_source_unique_name, 'budget')">{{ isUnlimited('budget', props.item) ? 'Unlimited' : `$${props.item.budget.toFixed(3)}` }}</span>
          <live-edit
            v-else
            :ref="`budgetLiveEdit-${props.i}`"
            :key="`budgetLiveEdit-${props.item.campaign_id}`"
            v-model="props.item.budget"
            :prefix="isUnlimited('budget', props.item) ? '' : '$'"
            :format="isUnlimited('budget', props.item) ? () => 'Unlimited' : ui.numFormat"
            field-name="Bid"
            :max-limit-warning="maxCpcLimit"
            :inlineEditable="false"
            @changeValue="$_showUpdateModal('budget', props.item)"
            :beforeBlur="value => $_updateBudget(props.item, value, props.item.budget_type)"
            @up="$_inlineEditArrayPress('bidLiveEdit', props.i, 'up')"
            @down="$_inlineEditArrayPress('bidLiveEdit', props.i, 'down')"
          />
        </template>
        <template
          slot="daily_budget"
          slot-scope="props"
        >
          <span v-if="props.item.daily_budget === 'null'">-</span>
          <span v-else-if="!isEditableField(props.item.traffic_source_unique_name, 'daily_budget')">{{ isUnlimited('daily_budget', props.item) ? 'Unlimited' : `$${props.item.daily_budget}` }}</span>
          <live-edit
            v-else
            :ref="`dailyBudgetLiveEdit-${props.i}`"
            :key="`dailyBudgetLiveEdit-${props.item.campaign_id}`"
            v-model="props.item.daily_budget"
            :prefix="isUnlimited('daily_budget', props.item) ? '' : '$'"
            :format="isUnlimited('daily_budget', props.item) ? () => 'Unlimited' : ui.numFormat"
            field-name="Bid"
            :max-limit-warning="maxCpcLimit"
            :inlineEditable="false"
            @changeValue="$_showUpdateModal('daily_budget', props.item)"
            :beforeBlur="value => $_updateDailyBudget(props.item, value)"
            @up="$_inlineEditArrayPress('bidLiveEdit', props.i, 'up')"
            @down="$_inlineEditArrayPress('bidLiveEdit', props.i, 'down')"
          />
        </template>
        <template
          slot="payout"
          slot-scope="props"
        >
          <live-edit
            :ref="`payoutLiveEdit-${props.i}`"
            :key="`payoutLiveEdit-${props.item.campaign_id}`"
            v-model="props.item.payout"
            :prefix="symbols.get(props.item.traffic_source_currency) || '$'"
            :format="ui.numFormat"
            :before-blur="value => $_updatePayout(props.item, value)"
            @up="$_inlineEditArrayPress('payoutLiveEdit', props.i, 'up')"
            @down="$_inlineEditArrayPress('payoutLiveEdit', props.i, 'down')"
          />
        </template>
        <template
          slot="status" slot-scope="props"
        >
          <span
            :class="`status-item status-item-${props.item.status}`"
            v-b-tooltip.hover.right
            :title="props.item.status.toUpperCase()"
            v-html="ui.campaign.status(props.item.status)"
          />
        </template>
        <template
          slot="avg_cpc"
          slot-scope="props"
        >
          <template>
            {{ ui.currencyFormat(props.item.avg_cpc, symbols.get(props.item.traffic_source_currency)) }}
          </template>
        </template>
        <template
          slot="byCountry" slot-scope="props"
        >
          <div v-if="props.items && !props.item.byCountry || (props.item.byCountry || []).length < 1">-</div>
          <div v-else>
            <div v-for="(bidItem, index) in props.item.byCountry" :key="index" style="display: inline-flex; margin-left: 5px; margin-right: 5px">
              <live-edit v-if="index < 3"
                         :ref="`bidLiveEdit-${bidItem.country}`"

                         :key="`bidLiveEdit-${index}-${bidItem.country}`"
                         :prefix="`${bidItem.country}: $`"
                         v-model="bidItem.countryBid"
                         :inline-editable="true"
                         field-name="Country Bid"
                         :format="ui.bidFormat"
                         :before-blur="value => $_changeCountryBid(props.item, value, bidItem.country)"
              />
            </div>
          </div>
          <b-btn style="margin-top: 5px;" v-if="props.item.byCountry && (props.item.byCountry || []).length>3" @click="$_showUpdateModal('byCountry', props.item)">Show bids for all countries</b-btn>
        </template>
      </vue-opti-table-light>
    </div>
    <update-modal
      :fieldName="fieldName"
      ref="updateModal"
      :supportedTypes="supportedTypes"
      :campaign="updateCampaign"
      @updateField="updateField"
      @updateCountryBid="$_changeCountryBid"
      :options="typeOptions"
      :min="0.01"
      :max="1"
      :step="0.01"
      right="<i class='fa fa-dollar'></i>"
    />
  </div>
</template>

<script>
import CampaignsPerformanceFilter from '@sh/components/Other/CampaignsPerformanceFilter';
import data from './data';
import tableFields from '@/helpers/fields/index.js';
import LiveEdit from '@sh/components/Utils/LiveEdit';
import notifications from '@sh/mixins/notifications';
import tableMixins from '@sh/mixins/table';
import campaignMixins from '@/mixins/campaign';
import UpdateModal from './components/UpdateModal';
import CampaignsStats from '@sh/components/Campaigns/CampaignsStats.vue';
import LoadingSkeleton from '@sh/components/Utils/Skeleton/LoadingSkeleton.vue';
import CampaignName from './components/CampaignName';
import config from '../Campaign/config.js';

export default {
  name: 'Campaigns',
  components: {
    CampaignsPerformanceFilter,
    LiveEdit,
    UpdateModal,
    CampaignsStats,
    LoadingSkeleton,
    CampaignName,
  },
  mixins: [notifications, tableMixins, campaignMixins],
  data,
  computed: {
    $c_tableHeaders() {
      return this.$_getFieldInfo(this.table.fields);
    },
    $c_reportingTimezone() {
      let { timezone } = this.filter.type;
      try {
        if (this.filter.accounts.length === 1 && this.filter.accounts[0].settings.timezone) {
          timezone = this.filter.accounts[0].settings.timezone;
        }
      } catch (error) {
        // Do nothing
      }
      return timezone;
    },
    $c_trackerAccounts() {
      const trackerAccounts = {};
      this.filter.trackers.forEach((acc) => {
        acc.id = parseInt(acc.id, 10);
        if (!trackerAccounts[acc.id]) trackerAccounts[acc.id] = { uniqueName: acc.uniqueName, name: acc.name };
      });
      return trackerAccounts;
    },
    $c_exportLabel() {
      return `${this.filter.type.name}_campaigns_performance_${this.filter.dateRange.startDate}_${this.filter.dateRange.endDate}`;
    },
    $c_readyAll() {
      return this.ready.filter && this.ready.campaigns;
    },
    $c_tableName() {
      return `${this.filter.type.name}CampaignsTable`;
    },
    $c_advertiserOptions() {
      const options = [{ value: 'all', content: 'All Advertisers' }];
      this.table.advertisers.forEach((item) => {
        options.push({ value: item.advertiser_id, content: item.advertiser_name });
      });
      return options;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    statusFilter(val) {
      this.debouncedGetCampaigns();
    },
    // eslint-disable-next-line no-unused-vars
    advertisersModel(value) {
      this.$_loadCampaignsPaginated();
    },
    'ready.hasData': (value) => {
      if (!value) this.$router.push({ name: 'AccountWizard' });
    },
  },
  async created() {
    // Register UserTask Action
    this.$_registerUserAction();

    /* *********** Promise Data Map  ************* */
    const [trackerAccounts] = await Promise.all([this.$api.trackers.accounts(), this.$_apiRules()]);
    trackerAccounts.forEach((item) => { this.$set(this.trackerAccountsMap, [item.id], item); });
    /* *********************************************** */
    this.debouncedGetCampaigns = this.debounce(this.$_loadCampaignsPaginated, 1000);
  },
  methods: {
    async updateField(fieldName, value, type) {
      const currentCampaign = this.updateCampaign;
      const currVal = type === 'unlimited' ? null : value;

      switch (fieldName) {
        case 'cpc':
          return this.$_updateBid(currentCampaign, value, type);
        case 'daily_budget':
          return this.$_updateDailyBudget(currentCampaign, currVal, type);
        case 'budget':
          return this.$_updateBudget(currentCampaign, currVal, type);
        default:
          return null;
      }
    },
    async $_showUpdateModal(field, campaign) {
      this.fieldName = field;
      this.updateCampaign = campaign;
      if (field === 'cpc') {
        this.typeOptions = config.bidTypeOptions[campaign.traffic_source_unique_name];
      }
      // if (field === 'byCountry') {
      //   this.typeOptions = [];
      // }
      this.supportedTypes = config[`supports_${field}_types`];
      this.editableFields = config.editableFields;
      this.$refs.updateModal.show(field, campaign);
    },
    // it is called on loading the page or when changin traffic source or tracker type
    // returns both first page elements and table totals and stats
    async $_loadCampaignsInit() {
      this.resizedColumns = this.$settings.resizedColumns.getResizedColumns('campaigns', this.filter.type.uniqueName);
      this.ready.campaigns = false;
      let response = {};
      let start;
      let end;
      try {
        // [this.trackerTypes, campaignsData] = await Promise.all([this.$_apiTrackersTypes(), this.$_apiCampaignsPerformance(this.filter.type.uniqueName, filter)])
        response = await this.$_apiCampaignsPerformancePaginated();
        start = new Date().getTime();
      } catch (error) {
        console.log(error);
        this.$n_failNotification({ title: error.response.data.message });
      }
      if (Object.keys(response).length > 0) {
        this.table.fields = [];
        this.table.fields.push(tableFields.getField('CAMPAIGNS', { name: 'actions' }));
        response.fields.forEach((item) => {
          this.table.fields.push(tableFields.getField('CAMPAIGNS', {
            name: item.item.key,
            uniqueName: this.filter.type.uniqueName,
          }, item));
        });
        this.campaigns = response.items.map((item) => {
          item.statusProcessing = false;
          item.unmanaged = item.unmanaged || false;
          return item;
        });
        this.table.items = this.campaigns;
        this.table.statsTotals = response.totals;
      }
      this.ready.campaigns = true;
      this.$nextTick(() => {
        end = new Date().getTime();
        console.log((end - start) / 1000);
      });
    },
    // called when table sort,pagination or limit is changed
    // returns only the elements of the table
    async $_loadCampaignsPaginated() {
      this.ready.pagination = true;
      let items = [];
      try {
        items = await this.$_apiCampaignsPerformancePaginated();
      } catch (error) {
        console.log(error);
        this.$n_failNotification({ title: error.response.data.message });
      }
      if (Object.keys(items).length > 0) {
        this.table.fields = [];
        this.table.fields.push(tableFields.getField('CAMPAIGNS', { name: 'actions' }));
        items.fields.forEach((item) => {
          this.table.fields.push(tableFields.getField('CAMPAIGNS', {
            name: item.item.key,
            uniqueName: this.filter.type.uniqueName,
          }, item));
        });
        this.campaigns = items.items.map((item) => {
          item.statusProcessing = false;
          return item;
        });
        this.table.items = this.campaigns;
      }
      this.ready.pagination = false;
    },
    // get paginated campaigns
    async $_apiCampaignsPerformancePaginated() {
      const filter = { startDate: this.filter.dateRange.startDate, endDate: this.filter.dateRange.endDate };
      filter.typeName = this.filter.type.uniqueName;
      filter.trafficSourceAccountIds = this.filter.accounts.map((item) => parseInt(item.id, 10));
      filter.trackerAccountIds = this.filter.trackers.map((item) => parseInt(item.id, 10));
      filter.page = this.page;
      filter.pageSize = this.limit;
      filter.sort = this.sortType === 'asc' ? `+${this.sortField}` : `-${this.sortField}`;
      filter.status = [];
      if (Object.keys(this.columnFilter).length) {
        filter.columnFilter = this.columnFilter;
      }

      if (this.statusFilter.length > 0) {
        // // eslint-disable-next-line
        if (this.statusFilter
          .map((selected) => selected.value.status)
          .includes('archived')) {
          filter.archived = true;
        }
        if (this.statusFilter
          .map((selected) => selected.value.status)
          .includes('unmanaged')) {
          filter.unmanaged = true;
        }
        if (this.statusFilter
          .map((selected) => selected.value.status)
          .includes('ispush')) {
          filter.is_push = true;
        }
        this.statusFilter.filter((filter) => !['archived', 'unmanaged', 'ispush'].includes(filter.value.status)).forEach((selected) => {
          if (selected.value.status) {
            filter.status.push(selected.value.status);
          }
        });
      }

      if (this.search !== '') {
        filter.search = this.search;
      }

      // const noTracker = filter.trackerAccountIds.indexOf(0) > -1;
      this.filter.accounts.forEach((item) => {
        filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // if (noTracker) {
        //   filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // } else if (item.trIds.filter((x) => filter.trackerAccountIds.includes(parseInt(x, 10))).length > 0) {
        //   filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // }
      });
      const items = await this.$api.campaigns.performance(filter);
      if (items.pagination.lastPage) {
        this.pages = items.pagination.lastPage;
        this.defaultRows = items.pagination.pageSize;
      }
      if (!items.items.length) {
        this.page = 1;
      }
      // load totals for pagination
      this.table.totals = items.totals;
      this.table.totals.totalElements = items.pagination.total;
      // Gemini Advertisers
      this.table.advertisers = items.advertisers || [];
      return items;
    },
    // get totals and stats
    async $_apiCampaignsTotals() {
      const filter = { startDate: this.filter.dateRange.startDate, endDate: this.filter.dateRange.endDate };
      filter.typeName = this.filter.type.uniqueName;
      filter.trafficSourceAccountIds = [];
      filter.trackerAccountIds = this.filter.trackers.map((item) => parseInt(item.id, 10));
      // const noTracker = filter.trackerAccountIds.indexOf(0) > -1;
      this.filter.accounts.forEach((item) => {
        filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // if (noTracker) {
        //   filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // } else if (item.trIds.filter((x) => filter.trackerAccountIds.includes(parseInt(x, 10))).length > 0) {
        //   filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
        // }
      });
      const [result] = await Promise.all([this.$api.campaigns.performanceTotals(filter)]);
      return result;
    },
    isEditableField(type, chField) {
      return config.editableFields[type] && config.editableFields[type].filter((field) => field.key === chField).length;
    },
    isUnlimited(field, item) {
      return item[`${field}_type`] === 'unlimited' || item[field] === 'unlimited' || item[field] === -1;
    },
    supportsBidType(type) {
      switch (type) {
        case 'Propeller':
          return true;
        case 'ExoClick':
          return true;
        case 'EzMob':
          return true;
        case 'Kadam':
          return true;
        default:
          return false;
      }
    },
    $_setSearchValue(event) {
      this.search = event.search;
      this.debouncedGetCampaigns();
    },
    // eslint-disable-next-line no-unused-vars
    $_setColumnFilterValues(event) {
      this.debouncedGetCampaigns();
    },
    $_setPaginationValues(event) {
      this.page = event.page;
      this.limit = event.limit;
      this.sortField = event.sortField;
      this.sortType = event.sortType;
      this.$_loadCampaignsPaginated();
    },
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        const context = this;
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    // eslint-disable-next-line no-unused-vars
    $_changeFilter(filter) {
      this.columnFilter = {};
      // Reset Advertiser
      this.advertisersModel = 'all';
      this.$_loadCampaignsInit();
      // this.renderKey = md5(JSON.stringify(filter));
    },
    async $_changeCountryBid(campaign, byCountry, country) {
      try {
        const { id, cpc, bid_strategy } = campaign;
        if (country) {
          const countryBid = byCountry;
          byCountry = campaign.bid_by_country.filter((item) => item.country !== country);
          byCountry.push({
            country,
            countryBid,
          });
        }
        await this.$api.campaigns.changeCampaignBid(id, cpc, bid_strategy, byCountry);
        this.$n_successNotification({ title: 'Bid successfully updated' });
        this.updateCampaign.byCountry = byCountry;
        return true;
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
      }
    },
    async $_updatePayout(item, value) {
      const task = this.userAction.task.create();
      try {
        const response = await this.$api.campaigns.changePayout(item.campaign_id, value);
        this.$n_successNotification({ title: response.message || 'Payout successfully updated' });
        task.finish();
        return true;
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
      }
      task.finish();
      return false;
    },
    $_inlineEditArrayPress(refName, index, direction) {
      let nextIndex = direction === 'up' ? index - 1 : index + 1;
      while (this.$refs[`${refName}-${nextIndex}`]) {
        if (this.$refs[`${refName}-${nextIndex}`].getState() === 'READY') {
          this.$refs[`${refName}-${nextIndex}`].focus();
          break;
        }
        nextIndex = direction === 'up~' ? nextIndex - 1 : nextIndex + 1;
      }
    },
    async $_bulkAction(action) {
      if (this.tableModel.selectedRows.length > 0) {
        const task = this.userAction.task.create();
        const timezone = this.$c_reportingTimezone;
        try {
          if (action === 'manage' || action === 'unmanage') {
            const unmanaged = action === 'unmanage';
            const selectedIds = this.tableModel.selectedRows.filter((row) => row.unmanaged !== unmanaged).map((row) => ({
              campaign_id: row.campaign_id,
              traffic_source_item_id: row.traffic_source_item_id,
              traffic_source_account_id: row.traffic_source_account_id,
              traffic_source_unique_name: row.traffic_source_unique_name,
              timezone,
            }));
            if (selectedIds.length > 0) {
              const result = await this.$api.campaigns.bulkActions('unmanaged', unmanaged, selectedIds);
              this.table.items.forEach((row) => {
                if (selectedIds.indexOf(row.campaign_id) > -1) row.unmanaged = unmanaged;
              });
              this.$n_successNotification({ title: result.message || 'Campaigns successfully updated' });
              this.$_loadCampaignsPaginated();
            }
          } else if (action === 'archive' || action === 'unarchive') {
            const archived = action === 'archive';
            const selectedIds = this.tableModel.selectedRows.filter((row) => row.archived !== archived).map((row) => ({
              campaign_id: row.campaign_id,
              traffic_source_item_id: row.traffic_source_item_id,
              traffic_source_account_id: row.traffic_source_account_id,
              traffic_source_unique_name: row.traffic_source_unique_name,
              timezone,
            }));
            if (selectedIds.length > 0) {
              const result = await this.$api.campaigns.bulkActions('archived', archived, selectedIds);
              this.table.items.forEach((row) => {
                if (selectedIds.indexOf(row.campaign_id) > -1) row.archived = archived;
              });
              this.$n_successNotification({ title: result.message || 'Campaigns successfully updatetd' });
              this.$_loadCampaignsPaginated();
            }
          }
        } catch (error) {
          console.log(error);
          let message = 'An error occurred';
          if (error.response && error.response.data && error.response.data.message) message = error.response.data.message;
          this.$n_failNotification({ title: message });
        }
        task.finish();
      } else {
        this.$n_failNotification({ title: 'Select at least 1 row' });
      }
    },
    async $_saveSettings(fields) {
      return this.$_saveSettingsOptions(fields, { type: this.filter.type.uniqueName, level: 'CAMPAIGN' });
    },
    $_handleColumnsResize(payload) {
      this.$settings.resizedColumns.setResizedColumns('campaigns', this.filter.type.uniqueName, payload);
    },
    $_exportCsvItems() {
      const filter = { startDate: this.filter.dateRange.startDate, endDate: this.filter.dateRange.endDate };
      filter.typeName = this.filter.type.uniqueName;
      filter.trafficSourceAccountIds = [];
      filter.trackerAccountIds = this.filter.trackers.map((item) => parseInt(item.id, 10));
      filter.page = 1;
      filter.pageSize = this.table.totals.totalElements;
      filter.sort = this.sortType === 'asc' ? `+${this.sortField}` : `-${this.sortField}`;
      filter.status = [];
      if (this.statusFilter.length > 0) {
        // eslint-disable-next-line
        if (this.statusFilter
          .map((selected) => selected.value.status)
          .includes('ARCHIVED')) {
          filter.archived = true;
        }
        if (this.statusFilter
          .map((selected) => selected.value.status)
          .includes('UNMANAGED')) {
          filter.managed = false;
        }

        this.statusFilter.filter((filter) => !['ARCHIVED', 'UNMANAGED'].includes(filter.value.status)).forEach((selected) => {
          if (selected.value.status) {
            filter.status.push(selected.value.status);
          }
        });
      }

      this.filter.accounts.forEach((item) => {
        filter.trafficSourceAccountIds.push(parseInt(item.id, 10));
      });
      return this.$_exportCsv({ level: 'campaigns', filter });
    },
  },
};
</script>

<style lang="scss">
  .campaigns-container {
    // .row > * {
    //   padding: .7rem;
    // }

    .margin-top {
      margin-top: 4rem;
    }

    .section-head {
      margin-bottom: 3rem;
      margin-top: 2rem;
      .section-title {
        font-size: 2.4rem;
        font-weight: bold;
        font-family: 'Inter', sans-serif;
        margin-bottom: .5rem;
        color: $color-dark-blue;
      }

      .section-subtitle {
        color: $text-secondary;
        font-size: 1.3rem;
      }
    }

    &__table {
      margin-top: 4rem;
      // overflow: hidden;

      .datatable-wrapper {
        .single-select-wrapper {
          padding-right: 0;

          .btn.dropdown-toggle {
            background: $color-white;
            color: $text-secondary;
            border-radius: .6rem;
            font-size: 1.4rem;
            padding: .7rem 1.5rem;
            border: .1rem solid $color-light-gray;
            transition: none;

            &:focus,
            &:active {
              background: $color-white;
              color: $text-secondary;
              border-color: $color-light-gray;
            }

            &::after {
              margin-left: 0;
            }
          }

          .dropdown-menu {
            padding: 1rem;
            background: $color-white;
            border: .1rem solid $color-light-gray;
            border-radius: .6rem;
            color: $color-dark;

            &::-webkit-scrollbar {
              width: .8rem;
            }

            li {
              line-height: unset;
              padding: 0;
              background: $color-white;

              &.active-item {
                background: $color-light !important;
              }

              a {
                display: flex;
                align-items: center;
                padding: .7rem 1.5rem .7rem 1.2rem;
                border-radius: .4rem;
                color: $black-600;
                font-size: 1.4rem;

                &:active,
                &:focus {
                  background: $color-light;
                }

                &:hover {
                  color: $color-dark;
                  background: $color-light;
                }
              }
            }
          }
        }
      }
    }
  }

</style>
